<ng-container>
    <p-confirmDialog #cd [styleClass]="dialog.title ? '' : 'sinHeader'" [style]="{width: '{{dialog.size}}vw'}" key="dialog" [closable]="false">
        <ng-template pTemplate="header">
            <div class="mt-2 ml-3" style="font-weight: 700; font-size: 16pt;">{{dialog.title}}</div>
        </ng-template>

        <ng-template pTemplate="footer">
            <button *ngFor="let opt of dialog.options; let index = index"
                    class="boton boton--w120px {{opt.class ? opt.class : ''}}" [ngClass]="{'boton--primario' : opt.type == OptionEnum.Positive  && !opt.class, 'boton--blanco' : opt.type == OptionEnum.Negative  && !opt.class, 'boton--separadoLeft' : index > 0}"
                (click)="opt.type == OptionEnum.Negative? cd.reject(): cd.accept()">
              {{opt.title}}
            </button>
        </ng-template>

    </p-confirmDialog>

</ng-container>
